var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"web-settings"},[(_vm.$mq === 'mobile')?_c('header-mobile-page',{attrs:{"label":_vm.child.name}}):_vm._e(),_c('website-settings',{attrs:{"mode-id":_vm.child.default_mode_id,"child-id":_vm.child.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }